module.exports = "./img/bc19dec0f3e8a5511be8f8172431b395.jpg";